import { colorLabEn } from "./colorlab.en.ts";
import { translate, type Translation } from "./lang.ts";

/**
 * Color Lab copy. Same house style as vi.ts: warm and plain, no dashes,
 * dots, slashes, symbols or parentheses. English twin in `colorlab.en.ts`.
 */
const source = {
  pours: (n: number) => `Đã rót ${n}`,
  stuck: "Kẹt rồi nè! Hoàn tác vài bước hoặc chơi lại nha.",
  hintCost: "Xài gợi ý thì màn này tối đa 2 sao thôi đó. Vẫn xài hông?",
  recipes: "Công thức bình pha",
  recipeWith: "với",
  recipeMakes: "thành",
  resultPours: (n: number, best: number) =>
    n <= best ? `Bạn rót ${n} lần, gọn y như lời giải đẹp nhất!` : `Bạn rót ${n} lần, lời giải gọn nhất là ${best} lần.`,
  resultRule: (three: number, two: number) => `Ba sao khi rót không quá ${three} lần, hai sao khi không quá ${two} lần.`,
  resultHint: "Có xài gợi ý nên tối đa 2 sao nha.",
};

export type ColorLabStrings = Translation<typeof source>;

export const colorLabVi: ColorLabStrings = translate(source, colorLabEn);
